import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../../contexts';
import { supabase } from '../../../lib/supabaseClient';

/**
 * 카카오 OAuth 콜백 페이지
 * Supabase 미사용 시 로그인 페이지로 리다이렉트
 */
const KakaoCallback: React.FC = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToast();

  useEffect(() => {
    // Supabase가 없으면 로그인 페이지로 리다이렉트
    if (!supabase) {
      showError('카카오 로그인은 현재 지원되지 않습니다');
      navigate('/login');
      return;
    }

    // Supabase의 인증 상태 변경 이벤트 리스너 설정
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {

      if (event === 'SIGNED_IN' && session) {

        // 사용자 정보에서 이름 가져오기
        const userName = session.user.user_metadata?.full_name ||
                        session.user.user_metadata?.name ||
                        session.user.email?.split('@')[0] || '사용자';

        // 환영 메시지
        showSuccess(`${userName}님, 환영합니다!`);

        // 짧은 지연 후 대시보드로 이동 (토스트 메시지 표시를 위해)
        setTimeout(() => {
          navigate('/dashboard');
        }, 1000);
      } else if (event === 'SIGNED_OUT') {
        showError('로그인에 실패했습니다');
        navigate('/login');
      }
    });

    // 즉시 세션 확인 (이미 로그인되어 있을 경우)
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        const userName = session.user.user_metadata?.full_name ||
                        session.user.user_metadata?.name ||
                        session.user.email?.split('@')[0] || '사용자';
        showSuccess(`${userName}님, 환영합니다!`);
        setTimeout(() => {
          navigate('/dashboard');
        }, 1000);
      }
    });

    // 클린업: 컴포넌트 언마운트 시 리스너 제거
    return () => {
      subscription.unsubscribe();
    };
  }, [navigate, showSuccess, showError]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-yellow-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-yellow-500 mx-auto mb-4"></div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">카카오 로그인 중...</h2>
        <p className="text-gray-600">잠시만 기다려주세요</p>
      </div>
    </div>
  );
};

export default KakaoCallback;
